
namespace TerminalApp {

    export class EditShipmentInfoAssistant {
        container = document.createElement("div");

        updatedLine: SP.UpdatedShipmentLine;

        callback: (warehouseReasonId: string, warehouseActionId: string, note: string) => void;

        constructor() {
            this.container.classList.add("assistant");
        }

        initialize() {
            // Close Button
            let close_button = this.container.appendChild(document.createElement("div"))
            close_button.classList.add("close");
            close_button.innerHTML = "X";
            //

            this.container.innerHTML += `
                <div class="return-edit-returnInfo-overall-container">

                    <div class="return-edit-returnInfo-container">
                        <h1 style="margin-top: 0 !important;">${SP.Localize("sentance_return_action")}</h1>
                        <select class="return-select selectReason">

                        </select>
                    </div>

                    <div class="return-edit-returnInfo-container">
                        <h1 style="margin-top: 0 !important;">${SP.Localize("sentance_return_reason")}</h1>
                        <select class="return-select selectAction">

                        </select>
                    </div>

                    <div class="return-edit-returnInfo-container">
                        <h1 style="margin-top: 0 !important;">${SP.Localize("word_note")}</h1>
                        <textarea class="return-note return-comment" placeholder="${SP.Localize("word_note")}">${this.updatedLine.note}</textarea>
                    </div>



                    <div class="return-edit-returnInfo-container" style="margin-top: 40px !important;">
                        <div class="btn noselect grad-green saveBtn"><span class="action">${SP.Localize("word_save")}</span></div>
                    </div>

                </div>
            `;

            // Close Button
            this.container.querySelector(".close").addEventListener("click", () => {
                this.close();
            });


            // Save Button
            this.container.querySelector(".saveBtn").addEventListener("click", () => {

                let warehouseReasonId = (this.container.querySelector(".selectReason") as HTMLSelectElement).value;
                let warehouseActionId = (this.container.querySelector(".selectAction") as HTMLSelectElement).value;
                let note = (this.container.querySelector(".return-note") as HTMLTextAreaElement).value;

                if (this.callback) {
                    this.callback(warehouseReasonId, warehouseActionId, note);
                }

                this.close();
            });


            this.populateActions();
            this.populateReasons();
        }

        async populateActions() {
            let actions = await SP.Data.WarehouseReasonsAndActions.getWarehouseActions();
            if (actions == null) {
                console.log("No actions")
                return;
            }
            
            let currentSelectedAction = actions.find((x) => x.id == this.updatedLine.warehouseActionId);
            
            let selectAction = this.container.querySelector(".selectAction") as HTMLSelectElement;
            for (let i = 0; i < actions.length; i++) {
                if (currentSelectedAction.returnActionType != SP.ReturnActionType.Exchange && actions[i].returnActionType != SP.ReturnActionType.Exchange) {
                    let isSelected = "";
                    if (this.updatedLine.warehouseActionId === actions[i].id) {
                        isSelected = "selected";
                    }

                    selectAction.innerHTML += `
                    <option value="${actions[i].id}" ${isSelected}>${actions[i].name}</option>
                `;   
                }
            }
        }

        async populateReasons() {
            let reasons = await SP.Data.WarehouseReasonsAndActions.getWarehouseReasons();
            if (reasons == null) {
                console.log("No reasons")
                return;   
            }

            let selectReason = this.container.querySelector(".selectReason") as HTMLSelectElement;
            for (let i = 0; i < reasons.length; i++) {

                let isSelected = "";
                if (this.updatedLine.warehouseReasonId === reasons[i].id) {
                    isSelected = "selected";
                }

                selectReason.innerHTML += `
                    <option value="${reasons[i].id}" ${isSelected}>${reasons[i].name}</option>
                `;
            }
        }

        open(callback: (warehouseReasonId: string, warehouseActionId: string, note: string) => void, line: SP.UpdatedShipmentLine) {
            this.callback = callback;
            this.updatedLine = line;
            this.container.style.display = "block";

            this.initialize();
        }

        close() {

            this.container.style.display = "none";
            this.reset();
        }

        reset() {
            this.container.innerHTML = "";
            this.updatedLine = null;
        }

    }
}